module.exports = __webpack_public_path__ + "media/application/images/services/secondary_nav/oil-and-gas-fdffb543980e1a77ec32f0b62ef93100.jpg";